import { createApp } from '@wu/widget-core';
import { AudioPlayer } from './AudioPlayer';
import { meta } from './constants';

export const createAudioPlayer = () => {
  return createApp(meta, AudioPlayer);
};

export { rss } from './components/sources';
